import React, { useState } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import './App.css';

function App() {
    const [activePage, setActivePage] = useState('home');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="App">
            <Header activePage={activePage} setActivePage={setActivePage} />
            <div className="app-body">
                <Sidebar
                    collapsed={sidebarCollapsed}
                    setCollapsed={setSidebarCollapsed}
                    activePage={activePage}
                    setActivePage={setActivePage}
                />
                <MainContent
                    activePage={activePage}
                    sidebarCollapsed={sidebarCollapsed}
                    setActivePage={setActivePage}
                />
            </div>
        </div>
    );
}

export default App;
